<header class="col-12 header-page row">
  <h1 class="col-7 px-0 header__page__content__title">
    Resgate da Reserva de Previdência
  </h1>
  <article>
    <p class="desc_card">
      Prezado participante, o simulador de resgate de reserva de poupança contempla as contribuições para o Plano
      III. Caso queira o valor referente ao BSA, favor solicitar pelo e-mail fundacao@fcopel.org.br.
      <br>
      Quanto à tabela progressiva, no ato do resgate é tributado 15%, e no ajuste anual poderá ser tributado a
      diferença até o total da tabela em 27,5%.
    </p>
  </article>
</header>

<ng-container >
  <spinner [show]="!reserva"></spinner>
</ng-container>

<main *ngIf="reserva">
  <h2 class="main__page__content__title col-7 px-0">
    Minha Reserva
  </h2>
  <section class="col-xl-12 col-12 px-1 card-container">
    <section class="card" [@fadeIn]>
      <span class="content__card__title">
        Valor Total de Contribuição
      </span>
      <p class="content__card__content">
        {{ reserva.total_Investido | currency:'BRL'}}
        <span class="fa-icon-dashboard fa-coin">$</span>
      </p>
    </section>
    <section class="card" [@fadeIn]>
      <span class="content__card__title">
        Total de Rendimentos das Contribuições
      </span>
      <p class="content__card__content">
        {{(reserva.total_Atualizado-reserva.total_Investido) | currency:'BRL'}}
        <span class="fa-icon-dashboard fa-coin">$</span>
      </p>
    </section>
    <section class="card" [@fadeIn]>
      <span class="content__card__title">
        Valor Total de Reserva
      </span>
      <p class="content__card__content">
        {{ reserva.total_Atualizado | currency:'BRL'}}
        <span class="fa-icon-dashboard fa-coin">$</span>
      </p>
    </section>
  </section>
  <section class="row">
    <section class="col-xl-6 col-sm-12 px-2">
      <h2 class="main__page__content__title col-xl-7 col-sm-12 px-0">
        Tabela Progressiva (IR)
      </h2>
      <div>
        <section class="content__header__table">
          <div class="col-xl-3">Valor Total de Reserva</div>
          <div class="col-xl-5">Valor Total de Imposto de Renda</div>
          <div class="col-xl-4">Valor Total Líquido</div>
        </section>
        <section class="content__main__table">
          <div class="table__card">
            <div class="col-xl-3">{{ reserva.total_Atualizado | currency:'BRL'}}</div>
            <div class="col-xl-5">{{ reserva.total_Irpf_Progressivo | currency:'BRL'}}</div>
            <div class="col-xl-4">{{ reserva.total_Liquido_Progressivo | currency:'BRL'}}</div>
          </div>
        </section>
      </div>
    </section>
    <section class="col-xl-6 col-sm-12 px-1">
      <h2 class="main__page__content__title col-xl-7 col-sm-12 px-0">
        Tabela Regressiva (IR)
      </h2>
      <div class="px-1">
        <section class="content__header__table">
          <div class="col-xl-3">Valor Total de Reserva</div>
          <div class="col-xl-5">Valor Total de Imposto de Renda</div>
          <div class="col-xl-4">Valor Total Líquido</div>
        </section>
        <section class="content__main__table">
          <div class="table__card">
            <div class="col-xl-3">{{ reserva.total_Atualizado | currency:'BRL'}}</div>
            <div class="col-xl-5">{{ reserva.total_Irpf_Regressivo | currency:'BRL'}}</div>
            <div class="col-xl-4">{{ reserva.total_Liquido_Regressivo | currency:'BRL'}}</div>
          </div>
        </section>
      </div>
    </section>
  </section>
</main>